import React, { memo } from 'react';
import { TLShipments } from '@/config/types/Routes';
import Icon from '@/components/Common/Icons/Icon';
import * as Icons from '@/components/Common/Icons/Icons';

interface TimelineIndicatorProps {
  shipments?: TLShipments[];
}

/**
 * TimelineIndicator component renders a small ADR SVG icon on the timeline box
 * if any of the provided shipments have ADR points assigned (> 0).
 *
 * Optimized for performance and narrow timeline boxes.
 */
export const TimelineIndicator: React.FC<TimelineIndicatorProps> = memo(
  ({ shipments }) => {
    // Only show the indicator if there is actually hazardous cargo (points > 0)
    const hasADR = shipments?.some((s) => (s.adr_points || 0) > 0);

    if (!hasADR) return null;

    return (
      <div
        style={{
          position: 'absolute',
          bottom: '4px',
          right: '4px',
          zIndex: 5,
          // Subtle drop shadow for contrast against different stop colors
          filter: 'drop-shadow(0 0 0.5px rgba(0,0,0,0.5))',
          lineHeight: 0,
          pointerEvents: 'none', // Ensure it doesn't interfere with timeline interactions
        }}
        title="ADR Cargo"
      >
        <Icon svg={Icons.adr} viewBox="0 0 103.5 103.425" fontSize={10} />
      </div>
    );
  }
);

TimelineIndicator.displayName = 'TimelineIndicator';
